import { gql } from "@apollo/client";

export const GET_ALL_ESTADO_MEDICO = gql`
    query getAllEstadoMedico{
        allEstadoCondicionalMedico
        {
            idEstadoCondicionalMedico,
            descripcion,
            codigo
        }
 }
`;